/**
 * Extend this class for more sophisticated events
 */
export class DefaultEvent { 
  constructor(payload) {
    this._payload = payload;

    this._name = null;
  }
  
  set name(name) {
    this._name = name;
  }

  get name() {
    return this._name;
  }

  set payload(payload) {
    this._payload = payload;
  }

  get payload() {
    return this._payload;
  }
}

export default DefaultEvent;


// WEBPACK FOOTER //
// ./client/app/shared/event/default.event.js